module.exports = __webpack_public_path__ + "img/IoTServe5.b057578f.png";